import { Environment } from "./environment.model";
import {
  AI_URL_PRODUCTION,
  BACKEND_PRODUCTION,
  CURRENCY_PRODUCTION,
  ETL_PRODUCTION,
  FIREBASE_PRODUCTION,
  FROALA_KEY,
  JOBS_PRODUCTION,
  LANGUAGES_PRODUCTION,
  PAY_URL_PRODUCTION,
  RC,
  REPORTS_PRODUCTION,
  VERSION,
  XLS_PRODUCTION,
  XLS_TEMPLATES_PRODUCTION,
  API_URL_PRODUCTION,
  NOTIFICATIONS_PRODUCTION,
} from "./global";

export const ENV: Environment = {
  backend: BACKEND_PRODUCTION,
  currency: CURRENCY_PRODUCTION,
  etl_url: ETL_PRODUCTION,
  api_url: API_URL_PRODUCTION,
  fileServerXlsxToJson: XLS_PRODUCTION,
  firebase: FIREBASE_PRODUCTION,
  froalaKey: FROALA_KEY,
  globalConfig: {
    _setTimeout: 200,
  },
  globalLanguages: LANGUAGES_PRODUCTION,
  ia_api_url: AI_URL_PRODUCTION,
  jobs_url: JOBS_PRODUCTION,
  mode: "Development",
  pay_api_url: PAY_URL_PRODUCTION,
  rebus_icon: "rebus",
  reports_url: REPORTS_PRODUCTION,
  notifications_url: NOTIFICATIONS_PRODUCTION,
  version: `${VERSION}${RC ? "-rc." + RC : ""}`,
  xls_templates: XLS_TEMPLATES_PRODUCTION,
};



// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts